import React, { useState, useEffect } from "react";
import {
  ArrowDown, ArrowUp, Building2, CalendarCheck, CalendarDays, CalendarRange, ChevronLeft, ChevronRight, CircleAlert,
  Crown, Download, FileText, Gift, Inbox, Search, Users
} from "lucide-react";
import dayjs from "dayjs";
import { AdminDashboardService } from "../../../../../../core/services/admin-dashboard.service";
import { NavLink } from "react-router-dom";
import "../signup.scss";
import "../../../../../../modules/shared/theme/theme.scss";
import "../admin-signups.scss";
import { Loading } from '../../../../../../redux/action';
import { connect } from 'react-redux';
import { RolesService } from "../../../../../../core/services/roles.service";
import { LocalService } from "../../../../../../core/services";
import { useNavigate } from 'react-router-dom';
import { Sheet } from "../../../../../../modules/shared/components/modals/Sheet";


const adminDashboardService = new AdminDashboardService();
const rolesService = new RolesService();
const localService: LocalService = new LocalService();

interface ColumnDisplayNames {
  [key: string]: string;
}

const columnDisplayNames: ColumnDisplayNames = {
  account_name: "Brand Name",
  // handle_name_ig: "IG Handle",
  // handle_name_yt: "YT Channel",
  agency_name: "Agency Name",
  email_primary: "Email",
  mobile_whatsapp: "Phone",
  created_at: "Signed up on",
  plan_start: "Plan Start Date",
  plan_end: "Plan End Date",
  Invoice: "Invoice",
};

const tableHeadColumnPart = [
  {
    name: "account_name",
    columnSize: "140px",
  },
  // {
  //   name: "handle_name_ig",
  //   columnSize: "165px",
  // },
  // {
  //   name: "handle_name_yt",
  //   columnSize: "165px",
  // },
  {
    name: "agency_name",
    columnSize: "140px",
  },
  {
    name: "email_primary",
    columnSize: "80px",
  },
  {
    name: "mobile_whatsapp",
    columnSize: "100px",
  },
  {
    name: "created_at",
    columnSize: "120px",
  },
  {
    name: "plan_start",
    columnSize: "120px",
  },
  {
    name: "plan_end",
    columnSize: "120px",
  },
  {
    name: "Invoice",
    columnSize: "120px",
  },
];

const status = [{
  value: 'All',
  label: 'All'
},
{
  value: 'Paid All',
  label: 'All Plans'
},
{
  value: 'Paid Monthly',
  label: 'Monthly Plan'
},
{
  value: 'Paid Quarterly',
  label: 'Quarterly Plan'
},
// {
//   value: 'Paid Half-Yearly',
//   label: 'Paid Half-Yearly'
// },
{
  value: 'Paid Yearly',
  label: 'Yearly Plan'
},
{
  value: 'Expired',
  label: 'Expired Plan'
},
{
  value: 'Free',
  label: 'Free'
},
];

interface Props {
  loading: (data: any) => any;
  userData: any;
}


const Brands: React.FC<Props> = (props: Props) => {
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const [orderBy, setOrderBy] = React.useState("");
  const [order, setOrder] = React.useState<"asc" | "desc">("asc");
  const [dashboardBasicData, setDashboardBasicData] = useState<any>([]);
  const [dashboardBriefData, setDashboardBriefData] = useState<any>([]);
  const [brandFilterData, setBrandFilterData] = useState<any>([]);
  const [filterLoading, setFilterLoading] = useState(false);
  const [statsLoading, setStatsLoading] = useState(false);
  const [dateError, setDateError] = useState("");
  const [showPop, setShowPop] = useState(false); 
  const [pageType, setPageType] = useState({
    value1: 'Brand',
    value2: 'Agency',
  })
  const navigate = useNavigate();

  const [formData, setFormData] = useState<any>({
    name: '',
    status: 'All',
    social_status: [],
    boolean_social_status: {
      ig_connected_active: false,
      ig_connected_non_active: false,
      yt_connected_active: false,
      yt_connected_non_active: false,
      non_connected: false,
    },
    start_date: '',
    end_date: '',
    value1: 'Brand',
    value2: 'Agency',
  });
  const dateFormat = "YYYY-MM-DD";

  const handleSort = (property: any) => {
    const isAsc = orderBy === property && order === "asc";
    setOrderBy(property);
    setOrder(isAsc ? "desc" : "asc");
  };

  const sortedData = React.useMemo(() => {
    if (Array.isArray(brandFilterData)) {
      const sortedArray = [...brandFilterData].sort((a, b) => {
        if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
        if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
        return 0;
      });
      return sortedArray;
    }
  }, [brandFilterData, orderBy, order]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  useEffect(() => {
    // CHECK IF USER ALLOWED  ACCESS 
    checkAccessFunction();
  }, []);

  const checkAccessFunction = async () => {
    try {
      const res = await rolesService.checkAccess({ access_roles: ["view_admin_dashboard"], user_id: props?.userData?.user_id })
      if (res.data.rows.length > 0) {
        getAdminDashboardSign();
      }
      else {
        localService.toastify("You are not allowed to access", "error", 1000);
        navigate(`/`);
      }
    }
    catch (error) {
      console.error('Error fetching getAdminDashData:', error);

    }
  }

  useEffect(() => {
    getAdminDashboardBrandFilter();
  }, [page]);

  async function getAdminDashboardSign() {
    try {
      setStatsLoading(true);
      const res = await adminDashboardService.getAdminDashData(pageType);
      if (res?.data?.status) {
        setDashboardBasicData(res.data.rows.basic_data[0]);
        setDashboardBriefData(res.data.rows.brief_related_data[0])
      }
    } catch (error) {
      console.error('Error fetching getAdminDashData:', error);
    } finally {
      setStatsLoading(false);
    }
  }

  async function getAdminDashboardBrandFilter() {
    try {
      setFilterLoading(true);
      const res = await adminDashboardService.getAdminDashFilter({
        value1: formData.value1,
        value2: formData.value2,
        start_date: formData.start_date,
        end_date: formData.end_date,
        filter: formData.status,
        name: formData.name,
        social_status: formData.social_status,
        boolean_social_status: formData.boolean_social_status,
        page: page + 1
      });
      if (res?.data?.status) {

        if (page === 0) {
          setBrandFilterData(res.data.rows);
        } else {
          setBrandFilterData((prevData: any) => [...prevData, ...res.data.rows]);
        }
      }
    } catch (error) {
      console.error('Error fetching getAdminDashboardSignFilter:', error);
    } finally {
      setFilterLoading(false);
    }
  }

  async function handleSearch(object: any) {
    try {
      if (formData.start_date === "" && formData.end_date != "") {
        setDateError("Please enter start date");
        return;
      } else {
        if (formData.end_date === "" && formData.start_date != "") {
          setDateError("Please enter end date");
          return;
        } else {
          if (formData.start_date > formData.end_date) {
            setDateError("Start date should be less than end date");
            return;
          } else {
            setDateError("");
            if (page === 0) {
              getAdminDashboardBrandFilter();
            } else {
              setPage(0);
            }
          }
        }
      }
    }
    catch (error) {
      console.error('Error fetching handleSearch:', error);
    } finally {
    }
  }

  const handleProposalClick = () => {
   setShowPop(true);
  };

  const handleCloseModal = () => {
    setShowPop(false);
  };

  const stats: { label: string; value: any; icon: React.ReactNode; tone: string; onClick?: () => void }[] = [
    { label: 'Total Brands', value: dashboardBasicData?.total_user_count, icon: <Building2 size={18} />, tone: 'primary' },
    { label: 'Briefs Posted', value: dashboardBriefData?.total_brief_posted, icon: <FileText size={18} />, tone: 'info' },
    { label: 'Proposals Received', value: dashboardBriefData?.total_proposals, icon: <Inbox size={18} />, tone: 'success', onClick: handleProposalClick },
    { label: 'Active Subscriptions', value: dashboardBasicData?.total_sub_count, icon: <Crown size={18} />, tone: 'violet' },
    { label: 'Monthly', value: dashboardBasicData?.monthly_sub_count, icon: <CalendarDays size={18} />, tone: 'info' },
    { label: 'Quarterly', value: dashboardBasicData?.quarterly_sub_count, icon: <CalendarRange size={18} />, tone: 'info' },
    { label: 'Yearly', value: dashboardBasicData?.annually_sub_count, icon: <CalendarCheck size={18} />, tone: 'info' },
    { label: 'Free Trial', value: dashboardBasicData?.unsubscribed_count, icon: <Gift size={18} />, tone: 'primary' },
  ];

  const total = (sortedData && sortedData[0]?.total_records) || 0;
  const pageCount = Math.max(1, Math.ceil(total / rowsPerPage));
  const today = dayjs().format(dateFormat);
  const visibleRows = sortedData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) || [];
  const truncate = (v: string, n: number) => (v.length > n ? `${v.substring(0, n)}…` : v);

  return (
    <div className="adminDashboardSignupMostOutterDiv">
      <div className="adminDashboardSignupContentOutterDiv">
        <div className="brd brd-admin">
          <header className="brd-page-head">
            <div className="brd-page-head__text">
              <h1 className="brd-page-head__title">Admin Dashboard</h1>
              <p className="brd-page-head__sub">Sign-ups and subscriptions across the platform.</p>
            </div>
          </header>

          <div className="brd-tabs brd-admin__tabs" role="tablist">
            <NavLink to="/brand/admin-dashboard/influencer-signups" className={({ isActive }) => `brd-tabs__tab${isActive ? ' brd-tabs__tab--on' : ''}`}>
              <Users size={16} /> Influencers
            </NavLink>
            <NavLink to="/brand/admin-dashboard/brand-signups" className={({ isActive }) => `brd-tabs__tab${isActive ? ' brd-tabs__tab--on' : ''}`}>
              <Building2 size={16} /> Brands
            </NavLink>
          </div>

          {/* Totals — Proposals Received opens its breakdown */}
          <div className="brd-admin-stats">
            {stats.map(s => {
              const body = (
                <>
                  <span className={`brd-admin-stat__icon brd-admin-stat__icon--${s.tone}`}>{s.icon}</span>
                  <span className="brd-admin-stat__label">{s.label}{s.onClick && <ChevronRight size={12} />}</span>
                  {statsLoading
                    ? <span className="brd-skeleton brd-admin-stat__skeleton" />
                    : <span className="brd-admin-stat__value">{s.value ?? 0}</span>}
                </>
              );
              return s.onClick
                ? <button key={s.label} type="button" className="brd-card brd-admin-stat brd-admin-stat--link" onClick={s.onClick}>{body}</button>
                : <div key={s.label} className="brd-card brd-admin-stat">{body}</div>;
            })}
          </div>

          {/* Filters */}
          <section className="brd-section brd-admin-filters">
            <div className="brd-admin-filters__row">
              <label className="brd-admin-filters__field brd-admin-filters__field--grow">
                <span>Name / Email / Phone</span>
                <span className="brd-search">
                  <Search size={16} />
                  <input value={formData.name} placeholder="Search…" aria-label="Name, email or phone"
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleSearch(formData); } }} />
                </span>
              </label>
              <label className="brd-admin-filters__field">
                <span>From</span>
                <input type="date" className="brd-input" max={today} value={formData.start_date}
                  onChange={(e) => setFormData({ ...formData, start_date: e.target.value })} />
              </label>
              <label className="brd-admin-filters__field">
                <span>To</span>
                <input type="date" className="brd-input" max={today} value={formData.end_date}
                  onChange={(e) => setFormData({ ...formData, end_date: e.target.value })} />
              </label>
              <button type="button" className="brd-btn brd-btn--primary brd-admin-filters__go" onClick={() => handleSearch(formData)} disabled={filterLoading}>
                {filterLoading ? <span className="brd-spinner brd-spinner--sm brd-spinner--light" /> : <Search size={16} />} Search
              </button>
            </div>
            {dateError.length > 0 && <p className="brd-field__error" role="alert"><CircleAlert size={13} /> {dateError}</p>}

            <div className="brd-admin-filters__group">
              <span className="brd-admin-filters__label">Plan</span>
              <div className="brd-chip-row" role="radiogroup" aria-label="Plan">
                {status.map((s) => (
                  <button key={s.value} type="button" role="radio" aria-checked={formData.status === s.value}
                    className={`brd-chip${formData.status === s.value ? ' brd-chip--on' : ''}`}
                    onClick={() => setFormData({ ...formData, status: s.value })}>
                    {s.label}
                  </button>
                ))}
              </div>
            </div>
          </section>

          <p className="brd-admin__total"><strong>{total}</strong> brand{total === 1 ? '' : 's'}</p>

          <div className="brd-card brd-admin-table">
            <div className="brd-admin-table__scroll">
              <table>
                <thead>
                  <tr>
                    {tableHeadColumnPart.map((column) => (
                      <th key={column.name} style={{ minWidth: column.columnSize }}>
                        {column.name === 'Invoice' ? columnDisplayNames[column.name] : (
                          <button type="button" className={`brd-admin-table__sort${orderBy === column.name ? ' brd-admin-table__sort--on' : ''}`}
                            onClick={() => handleSort(column.name)}>
                            {columnDisplayNames[column.name] || column.name}
                            {orderBy === column.name && order === 'desc' ? <ArrowDown size={12} /> : <ArrowUp size={12} />}
                          </button>
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filterLoading && visibleRows.length === 0 ? (
                    Array.from({ length: 5 }, (_, i) => (
                      <tr key={i}>{tableHeadColumnPart.map((c) => <td key={c.name}><span className="brd-skeleton brd-admin-table__skeleton" /></td>)}</tr>
                    ))
                  ) : visibleRows.length === 0 ? (
                    <tr><td colSpan={tableHeadColumnPart.length} className="brd-admin-table__empty">No brands match these filters.</td></tr>
                  ) : visibleRows.map((row: any, i: number) => (
                    <tr key={`${page}-${i}`} className={filterLoading ? 'brd-admin-table__row--busy' : ''}>
                      <td><span className="brd-admin-table__strong" title={row.name}>{row.name ? truncate(row.name, 22) : '—'}</span></td>
                      <td title={row.account_name}>{row.account_name ? truncate(row.account_name, 22) : '—'}</td>
                      <td title={row.primary_email}>{row.primary_email ? truncate(row.primary_email, 24) : '—'}</td>
                      <td className="brd-admin-table__nowrap">{row.primary_phone || '—'}</td>
                      <td className="brd-admin-table__nowrap">{row.created_at ? dayjs(row.created_at).format('D MMM YYYY') : '—'}</td>
                      <td className="brd-admin-table__nowrap">{row.plan_start ? dayjs(row.plan_start).format('D MMM YYYY') : '—'}</td>
                      <td className="brd-admin-table__nowrap">{row.plan_end ? dayjs(row.plan_end).format('D MMM YYYY') : '—'}</td>
                      <td>
                        <button type="button" className="brd-btn brd-btn--outline brd-btn--sm"><Download size={14} /> Download</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="brd-admin-pager">
              <span>{total ? `${page * rowsPerPage + 1}–${Math.min(total, (page + 1) * rowsPerPage)} of ${total}` : '0 of 0'}</span>
              <button type="button" className="brd-icon-btn" disabled={page === 0 || filterLoading} onClick={(e) => handleChangePage(e, page - 1)} aria-label="Previous page"><ChevronLeft size={18} /></button>
              <button type="button" className="brd-icon-btn" disabled={page + 1 >= pageCount || filterLoading} onClick={(e) => handleChangePage(e, page + 1)} aria-label="Next page"><ChevronRight size={18} /></button>
            </div>
          </div>
        </div>

        <Sheet open={showPop} onClose={handleCloseModal} size="small" title="Proposals received"
          subtitle={`${dashboardBriefData?.total_proposals ?? 0} in total`}>
          <ul className="brd-admin-breakdown">
            <li><span className="brd-pill brd-pill--success">Accepted</span><strong>{dashboardBriefData?.total_accepted_proposal ?? 0}</strong></li>
            <li><span className="brd-pill brd-pill--error">Rejected</span><strong>{dashboardBriefData?.total_rejected_proposal ?? 0}</strong></li>
            <li><span className="brd-pill brd-pill--info">Shortlisted</span><strong>{dashboardBriefData?.total_shortlist_proposal ?? 0}</strong></li>
          </ul>
        </Sheet>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userData: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(Brands);
export { connectToRedux as Brands };
